<template>
  <div class="" style="text-align: left; min-height: 75vh;">
    <div class="container" style="padding-top: 50px; padding-bottom: 50px;">
      <span>
        <router-link
          class=""
          style="text-decoration: none;"
          id=""
          :to="{ name: 'Landing', params: {} }"
        >
          <span class="">Home</span>
        </router-link>
        |
        <span style="color: #F5AD0B;">Terms & conditions</span>
      </span>
      <h1 v-if="terms" style="font-weight: bold;">{{ terms.title }}</h1>
    </div>
    <div class="container-fluid" style="background: #F7F8FC;">
      <div v-if="terms" class="container" v-html="terms.text"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Terms",
  data() {
    return {
      terms: null,
      idList: JSON.parse(localStorage.getItem("avLanguages")),
    };
  },
  async mounted() {
    this.getterms();
  },

  methods: {
    getterms() {
      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      let dynamicId = this.idList.find((e) => e.code === this.$i18n.locale).id;

      fetch(
        this.apiReq + "/api/v1/page/terms?languageId=" + dynamicId,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 200) {
            this.terms = result.page;
          } else {
            console.log(result);
          }
        })
        .catch((error) => console.log("error", error));
    },
  },

  components: {},
  props: {},

  computed: {
    ...mapGetters(["apiReq"]),
  },
};
</script>

<style scoped></style>
